// extracted by css-extract-rspack-plugin
export default {"titleCardContainer":"Card_titleCardContainer__2OTZL"};